/**
 * Timestamped transcript with clickable segments that seek the video.
 */
import React from 'react';

export default function TranscriptView({ segments = [], fullText = '', onSeek }) {
  if (!segments.length) {
    return (
      <div className="text-gray-500 text-sm whitespace-pre-wrap">
        {fullText || 'No transcript available.'}
      </div>
    );
  }

  return (
    <div className="space-y-3 max-h-[420px] overflow-y-auto scrollbar-thin pr-2">
      {segments.map((seg) => (
        <div key={seg.id ?? seg.start} className="flex gap-3">
          <button
            type="button"
            onClick={() => onSeek && onSeek(seg.start)}
            className="shrink-0 text-brand-600 font-mono text-xs hover:underline pt-0.5"
          >
            {seg.timestamp}
          </button>
          <p className="text-sm text-gray-700">{seg.text}</p>
        </div>
      ))}
    </div>
  );
}
